import { graphql } from '@/__generated__';
import { useCacheMonitor } from '@/context/DiscoveryUrqlProvider';
import { useQueryStable } from '../useQueryStable';

// https://github.com/dbt-labs/codex-api/blob/main/schema.graphql
// https://github.com/dbt-labs/codex-api/blob/main/frontend/package.json#L33
// https://github.com/dbt-labs/codex-api/blob/main/frontend/codegen.yml
// generates: https://github.com/dbt-labs/codex-api/blob/main/frontend/src/typings/codex.ts
export const GetSourceCollectionBySourceName = graphql(/* GraphQL */ `
  query AppliedSourceCollection($environmentId: BigInt!, $sourceNames: [String!]) {
    environment(id: $environmentId) {
      applied {
        lastUpdatedAt
        latestGitSha
        sources(first: 1, filter: { sourceNames: $sourceNames }) {
          totalCount
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              uniqueId
              filePath
              meta
              database
              schema
              loader
              sourceDescription
              sourceName
            }
          }
        }
      }
    }
  }
`);

type SourceCollectionByEnvironmentParams = {
  environmentId: number | undefined;
  userId: number | 'loading' | null;
  sourceName: string | undefined;
  pause?: boolean;
};

export const useDiscoveryAppliedSourceCollection = ({
  environmentId = 0,
  userId,
  sourceName,
  pause,
}: SourceCollectionByEnvironmentParams) => {
  const query = useQueryStable({
    query: GetSourceCollectionBySourceName,
    variables: {
      environmentId,
      sourceNames: [sourceName!],
      userId: userId as number | null,
    },
    pause: pause || !environmentId || !sourceName || userId === 'loading',
  });

  useCacheMonitor({
    applied: query[0].data?.environment.applied?.lastUpdatedAt,
  });

  return query;
};
